import { render, staticRenderFns } from "./proposal-edit.vue?vue&type=template&id=fc15ffa2&scoped=true&"
import script from "./proposal-edit.vue?vue&type=script&lang=ts&"
export * from "./proposal-edit.vue?vue&type=script&lang=ts&"
import style0 from "./proposal-edit.vue?vue&type=style&index=0&id=fc15ffa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc15ffa2",
  null
  
)

export default component.exports